import { useRouter } from 'next/router';
import React from 'react';

import { useSettingsModal } from '../../contexts/SettingsModalContext';
import TextLogoSvg from '../assets/logo-text.svg';
import { withLink } from '../core/hocs';
import { SegmentedControl } from '../core/SegmentedControl';
import { SegmentedControlType } from '../core/SegmentedControl/SegmentedControl.consts';

import {
  NAV_SEGMENT_DISPLAY_NAMES,
  NAV_SEGMENT_ROUTES,
  NavSegment
} from './Nav.consts';
import { ProfileButton } from './ProfileButton';

import { Icon, IconButton, IconButtonType, Size } from '~/components/core';
import { PUBLIC_DOCS_URL, ROOT_ROUTE, WORKFLOWS_ROUTE } from '~/constants';

const Nav = () => {
  const router = useRouter();
  const { openSettingsModal } = useSettingsModal();

  // Initialize navSegment based on current route
  const getCurrentSegment = (): NavSegment => {
    if (router.pathname.includes(WORKFLOWS_ROUTE)) return NavSegment.AGENTS;
    return NavSegment.CHAT;
  };

  return (
    <nav
      className="border-primary-border relative flex h-14 w-full flex-row items-center justify-between border-b px-3 sm:px-6"
      data-testid="nav-container"
    >
      <div
        className="flex flex-row items-center gap-0.5 sm:gap-1 md:gap-2"
        data-testid="nav-logo-group"
      >
        {/* New Chat (Home) */}
        {withLink(
          <span className="w-32 text-white" data-testid="nav-logo-container">
            <TextLogoSvg />
          </span>,
          { href: ROOT_ROUTE, fullSize: true }
        )}
      </div>
      <div
        className="flex flex-row items-center gap-0.5 sm:gap-1 md:gap-2"
        data-testid="nav-center-group"
      >
        <div
          className="absolute left-1/2 top-1/2 w-auto min-w-0 -translate-x-1/2 -translate-y-1/2"
          data-testid="nav-segmented-control"
        >
          <SegmentedControl
            segmentOptions={[
              {
                label: NAV_SEGMENT_DISPLAY_NAMES[NavSegment.CHAT],
                value: NavSegment.CHAT,
                icon: Icon.CHAT,
                href: NAV_SEGMENT_ROUTES[NavSegment.CHAT]
              },
              {
                label: NAV_SEGMENT_DISPLAY_NAMES[NavSegment.AGENTS],
                value: NavSegment.AGENTS,
                icon: Icon.BOLT,
                href: NAV_SEGMENT_ROUTES[NavSegment.AGENTS]
              }
            ]}
            type={SegmentedControlType.SOLID_HIGHLIGHT}
            value={getCurrentSegment()}
          />
        </div>
      </div>
      <div
        className="flex flex-row items-center gap-0.5 sm:gap-1 md:gap-2"
        data-testid="nav-actions-group"
      >
        {/* Settings */}
        <IconButton
          data-id="nav_settings"
          highlightOnHover
          icon={Icon.SETTINGS}
          onClick={() => openSettingsModal()}
          size={Size.LARGE}
          type={IconButtonType.NONE}
        />
        {/* External Documentation */}
        {withLink(
          <IconButton
            data-id="nav_support"
            highlightOnHover
            icon={Icon.SUPPORT}
            onClick={() => {}}
            size={Size.LARGE}
            type={IconButtonType.NONE}
          />,
          {
            href: PUBLIC_DOCS_URL,
            newTab: true
          }
        )}
        {/* Profile */}
        <ProfileButton />
      </div>
    </nav>
  );
};

export default React.memo(Nav);
